import React from 'react';
import { Invitation } from '../../stores/reducers/invitations';
import Avatar from '../general-components/avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import Icon, { ICONS, COLORS } from '../general-components/icon';
import classNames from 'classnames';

interface InviteRequestProps {
	invite: Invitation;
	approve: (ev: Invitation) => void;
	block: (ev: Invitation) => void;
	small?: boolean;
}

export default function InviteRequest(props: InviteRequestProps) {
	const {
		invite: {
			profile
		},
		approve,
		block,
		small
	} = props;

	return (
		<div className={classNames("invite-request", { small: small })}>
			<Avatar
				user={profile}
				size={small ? 'thirtytwo' : 'small'}
				noBorder={true}
			/>
			<label>{profile.first_name} {profile.last_name}</label>
			<div className="invite-actions">
				<button
					onClick={() => block(props.invite)}
					className="block">
					<Icon name={ICONS.CLOSE} color={COLORS.WHITE} size={15} />
				</button>
				<button
					onClick={() => approve(props.invite)}
					className="accept">
					<Icon name={ICONS.CHECK} size={15} color={COLORS.BLACK} />
				</button>

			</div>
		</div>
	)
}